"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-6cc8601f"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "text-left flex-column generator-container" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", null, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("h5", null, "AIでシフトを作成してみましょう。"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "font-sm" }, "業務管理ページで選択した業務と設定に基づいて、AIが月間のシフトを自動作成します。各業務に割り当てるスタッフや1日の必要人数も考慮されます。")
], -1 /* HOISTED */));
const _hoisted_3 = { class: "flex-column flex-gap" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("h5", { class: "m-0" }, "シフトの微調整", -1 /* HOISTED */));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "font-sm" }, "シフトをより最適化するために、下のテキストボックスに追加条件を入力できます。", -1 /* HOISTED */));
const _hoisted_6 = {
    key: 0,
    class: "accordion"
};
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("input", {
    type: "checkbox",
    id: "accordion-history",
    name: "accordion-checkbox",
    hidden: ""
}, null, -1 /* HOISTED */));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("label", {
    class: "accordion-header p-0",
    for: "accordion-history"
}, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right mr-1" }),
    /*#__PURE__*/ (0, vue_2.createTextVNode)(" 履歴 ")
], -1 /* HOISTED */));
const _hoisted_9 = { class: "accordion-body mb-0" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "font-sm" }, "※AIが作成した内容は、自動処理の性質上、誤った日付や意図しない割り当てが含まれる可能性があります。内容を確認のうえ、必要に応じて修正してください。", -1 /* HOISTED */));
const vue_3 = require("vue");
const provider_1 = require("../../../../provider/provider");
const AutoAIPromptHistory_vue_1 = __importDefault(require("./AutoAIPromptHistory.vue"));
const autoAIStorage_1 = require("../../../../storage/autoAIStorage");
exports.default = (0, vue_1.defineComponent)({
    __name: 'AutoAIShiftGenerator',
    setup(__props) {
        const viewModel = (0, vue_3.inject)(provider_1.autoAIViewModelInjectKey);
        const presenter = (0, vue_3.inject)(provider_1.autoAIPresenterInjectKey);
        const instructions = (0, vue_3.computed)({
            get: () => viewModel?.value.instructions || '',
            set: (text) => presenter?.setIntructions(text),
        });
        const promptHistory = (0, vue_3.computed)(() => {
            return viewModel?.value.promptHistory || [];
        });
        const showPromptHistory = (0, vue_3.computed)(() => {
            return promptHistory.value.length > 0;
        });
        async function deletePrompt(prompt) {
            if (!viewModel?.value) {
                return;
            }
            await (0, autoAIStorage_1.deleteAutoAIPrompt)(prompt, viewModel.value.userId, viewModel.value.branchId);
            presenter?.deletePromptHistory(prompt.id);
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                _hoisted_2,
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    _hoisted_4,
                    _hoisted_5,
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("textarea", {
                        class: "form-input generator-text",
                        rows: "5",
                        placeholder: "例①）目的と優先順位をわかりやすく記載すると、AIが要望をくみ取りやすくなります！〇〇を△△したい。まずは業務Aが〇〇で△△してください。次に〇〇を優先してください。\n\n例②）会話をするように指示出しをすることも可能です！Aさんは夜勤少なめにしてあげて。BさんとCさんはスキルがあるから、業務〇〇ができれば被らないほうがいいです。〇日はイベントだから、必要人数より〇人多く割り振ってほしい！\n\nアルバイトのタグがついたスタッフは公休を〇日以上にする。\n新人のタグがついているスタッフは、必ずリーダーのタグがついたスタッフと同じ時間、同じ業務を割り振る。",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((instructions).value = $event))
                    }, null, 512 /* NEED_PATCH */), [
                        [vue_2.vModelText, instructions.value]
                    ])
                ]),
                (showPromptHistory.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, [
                        _hoisted_7,
                        _hoisted_8,
                        (0, vue_2.createElementVNode)("div", _hoisted_9, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(promptHistory.value, (prompt) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(AutoAIPromptHistory_vue_1.default, {
                                    prompt: prompt,
                                    onDeletePrompt: deletePrompt
                                }, null, 8 /* PROPS */, ["prompt"]));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                _hoisted_10
            ]));
        };
    }
});
